import type { AccountSummary } from "../types/account";

export const ACTIVE_ACCOUNT_STORAGE_PREFIX = "@neqraw/active-account/v1/";

/**
 * The active account is a preference, so its storage namespace is scoped to
 * the Firebase controller. It is never an authorization lookup.
 */
export function activeAccountStorageKey(uid: string) {
  return `${ACTIVE_ACCOUNT_STORAGE_PREFIX}${encodeURIComponent(uid)}`;
}

export function isUsableAccount(account: AccountSummary | null | undefined) {
  return !!account && account.status === "active";
}

/**
 * Restore a local selection only when it is present in the fresh server list;
 * otherwise prefer the personal account and finally the first usable account.
 */
export function chooseActiveAccount(
  accounts: readonly AccountSummary[],
  persistedAccountId: string | null | undefined,
  personalAccountId: string | null | undefined
) {
  const usable = accounts.filter(isUsableAccount);
  return usable.find((account) => account.accountId === persistedAccountId)
    ?? usable.find((account) => account.accountId === personalAccountId || account.isPersonal)
    ?? usable[0]
    ?? null;
}

export function accountCanBeSelected(
  accounts: readonly AccountSummary[],
  accountId: string | null | undefined
) {
  return !!accountId && accounts.some(
    (account) => account.accountId === accountId && isUsableAccount(account)
  );
}
